import React from 'react';
import { StickyAlertBar } from './components/StickyAlertBar';
import { HeroSection } from './components/HeroSection';
import { PainSection } from './components/PainSection';
import { EnemySection } from './components/EnemySection';
import { RevelationSection } from './components/RevelationSection';
import { ProductPresentation } from './components/ProductPresentation';
import { WhatYouGetSection } from './components/WhatYouGetSection';
import { BonusSection } from './components/BonusSection';
import { ResultSection } from './components/ResultSection';
import { PricingSection } from './components/PricingSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { ScarcitySection } from './components/ScarcitySection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <main className="bg-brand-black min-h-screen text-gray-200 selection:bg-brand-red selection:text-white overflow-x-hidden" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <StickyAlertBar data-id="element-2" />
      <HeroSection data-id="element-3" />
      <PainSection data-id="element-4" />
      <EnemySection data-id="element-5" />
      <RevelationSection data-id="element-6" />
      <ProductPresentation data-id="element-7" />
      <WhatYouGetSection data-id="element-8" />
      <BonusSection data-id="element-9" />
      <ResultSection data-id="element-10" />
      <PricingSection data-id="element-11" />
      <GuaranteeSection data-id="element-12" />
      <ScarcitySection data-id="element-13" />
      <FinalCTA data-id="element-14" />
      <Footer data-id="element-15" />
    </main>;
}